import React from 'react'
import { Link } from 'gatsby'

const Header = () => {
  const menu = () => {
    const hamburger = document.querySelector(".hamburger");
    const menues = document.querySelectorAll(".icon");
    hamburger.classList.toggle("visible");
    menues.forEach((menu) => {
      menu.classList.toggle("vanish");
    });
  }
  return (
    <header>
      <div className="header">
        <h1 className='title'><Link to={'/'}>KameWalk</Link></h1>
        <nav>
          <ul className="main-nav">
            <li><Link to={'/'} className='under-line'>HOME</Link></li>
            <li><Link to={'/about/'} className='under-line'>ABOUT</Link></li>
          </ul>
        </nav>
        <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" className="icon" viewBox="0 0 24 24" onClick={menu}><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" className="icon vanish" viewBox="0 0 24 24" onClick={menu}><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      </div>
      <nav className="hamburger">
        <ul className="main-nav">
          <li><Link to={'/'} className='under-line'>HOME</Link></li>
          <li><Link to={'/about/'} className='under-line'>ABOUT</Link></li>
        </ul>
      </nav>
    </header>
  )
}
export default Header;